import { render, staticRenderFns } from "./economy-total1.vue?vue&type=template&id=77123fb4&scoped=true"
import script from "./economy-total1.vue?vue&type=script&lang=js"
export * from "./economy-total1.vue?vue&type=script&lang=js"
import style0 from "./economy-total1.vue?vue&type=style&index=0&id=77123fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77123fb4",
  null
  
)

export default component.exports